import React from 'react';
import PropTypes from 'prop-types';

const Highlight = (props) => {
  const { children, isHighlight, highlightColor = '#ed4646' } = props;
  return <span style={isHighlight ? { color: highlightColor } : {}}>{children}</span>;
};
Highlight.defaultProps = {
  highlightColor: '#ed4646',
  isHighlight: false,
};

Highlight.propTypes = {
  children: PropTypes.node.isRequired,
  isHighlight: PropTypes.bool,
  highlightColor: PropTypes.string,
};

export default Highlight;
